export default __webpack_public_path__ + "static/media/carmen.190e0001.jpg";